import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Formio } from 'formiojs';
import { AppService } from '../app.service';
import { Guid } from "guid-typescript";
import { FormioExport } from 'formio-export';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-arb-exp-component',
  templateUrl: './arb-exp.component.html'
})
export class ArbExpComponent {
  formSpec: any;
  formData: any;
  formId = Guid.create().toJSON().value;
  router: Router;
  httpClient: HttpClient;
  appService: AppService;
  baseUrl: string;
  jsonDataUrl: string;
  formComponents: any;
  triggerRefresh: any;
  constructor(router: Router, appService: AppService, httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private route: ActivatedRoute) {
    this.router = router;
    this.httpClient = httpClient;
    this.baseUrl = baseUrl;
    this.appService = appService;
    this.route.queryParamMap
      .subscribe(params => {
        this.jsonDataUrl = params.get('jsonUrl')
      });
  }

 
  
  ngOnInit() {
    var formComponents = [

      {
        "html": "<p>This application form covers the nomination of dispute resolvers for mediations, arbitrations, expert determinations and conciliations.</p><p>This form requires the following information:</p><p>- Contact details of ALL parties and legal representatives (name, email, phone number, postal address, etc)</p><p>- Amount disputed.</p><p>- Area of dispute.</p><p>- Brief outline of dispute.</p><p>Please also attach: Dispute Resolution clause (if any), Notice of dispute and any other relevant documentation.</p>",
        "label": "Content",
        "refreshOnChange": false,
        "key": "content",
        "type": "content",
        "input": false,
        "tableView": false
      },

      {
        "type": "radio",
        "label": "I acknowledge the above",
        "input": true,
        "inline": true,
        "tableView": false,
        "key": "agreementWithIntroInfo",
        "persistent": true,
        values: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        "validate": {
          "required": true
        }
      },


      {
        type: "select",
        label: "Type of dispute resolver being nominated",
        key: "typeOfDisputeResolver",
        placeholder: "Select one",
        data: {
          values: [
            { value: 'arbitrator', label: 'Arbitrator' },
            { value: 'mediator', label: 'Mediator' },
            { value: 'conciliator', label: 'Conciliator' },
            { value: 'expert Determiner', label: 'Expert Determiner' }
          ]
        },
        "validate": {
          "required": true
        },
        dataSrc: "values",
        defaultValue: '',
        template: "<span>{{ item.label }}</span>",
        input: true

      },
      // party1 start
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Party 1 Name (Company)",
        "key": "party1NameCompany",
        "placeholder": "Name",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        type: "select",
        label: "Role in dispute",
        key: "roleInDispute",
        placeholder: "Select one",
        data: {
          values: [
            { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
            { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
            { value: 'partyInArbitrator', label: 'Party In Arbitration' }
          ]
        },
        "validate": {
          "required": true
        },
        dataSrc: "values",
        defaultValue: '',
        template: "<span>{{ item.label }}</span>",
        input: true,
        //"conditional": {
        //  "json": {
        //    "===": [
        //      {
        //        "var": "data.typeOfDisputeResolver"
        //      },
        //      "arbitrator"
        //    ]
        //  }
        //}      
      },
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDispute",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInMediation', label: 'Party In Mediation' }
      //    ]
      //  },
      //  "validate": {
      //    "required": true
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  //"conditional": {
      //  //  "json": {
      //  //    "===": [
      //  //      {
      //  //        "var": "data.typeOfDisputeResolver"
      //  //      },
      //  //      "mediator"
      //  //    ]
      //  //  }
      //  //}
      //},
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDispute",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInConciliation', label: 'Party In Conciliation' }
      //    ]
      //  },
      //  "validate": {
      //    "required": true
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  "conditional": {
      //    "json": {
      //      "===": [
      //        {
      //          "var": "data.typeOfDisputeResolver"
      //        },
      //        "conciliator"
      //      ]
      //    }
      //  }
      //},
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDispute",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInExpertDetermination', label: 'Party In Expert Determination' }
      //    ]
      //  },
      //  "validate": {
      //    "required": true
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  "conditional": {
      //    "json": {
      //      "===": [
      //        {
      //          "var": "data.typeOfDisputeResolver"
      //        },
      //        "expert Determiner"
      //      ]
      //    }
      //  }
      //},
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Contact Given name",
        "key": "contactGivenName",
        "placeholder": "Name",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Contact Surname",
        "key": "contactSurname",
        "placeholder": "Surname",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Position",
        "key": "position",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postal Address",
        "key": "postalAddress",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Suburb",
        "key": "suburb",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "State",
        "key": "state",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postcode",
        "key": "postCode",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false,
          "pattern": "^[0-9]+$"
        }
      },
      {
        "label": "Telephone number",
        "inputMask": "(99) 9999-9999",
        "tableView": true,
        "persistent": true,
        "validate": {
          "required": false,
          "customPrivate": false
        },
        "key": "telephoneNumber",
        "type": "textfield",
        "input": true
      },

      {
        "label": "Email",
        "tableView": true,
        "validate": {
          "required": true
        },
        "key": "email",
        "type": "email",
        "input": true
      },
      {
        "type": "radio",
        "label": "Representative",
        "input": true,
        "inline": true,
        "tableView": false,
        "key": "representative1",
        "persistent": true,
        values: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        "validate": {
          "required": true
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Firm/Chambers",
        "key": "representative1FirmChambers",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.representative1"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Name of representative",
        "key": "nameOfRepresentative1",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.representative1"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postal Address",
        "key": "representative1PostalAddress",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.representative1"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Suburb",
        "key": "representative1Suburb",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.representative1"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "State",
        "key": "representative1State",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.representative1"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postcode",
        "key": "representative1PostCode",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.representative1"
              },
              "yes"
            ]
          }
        },
        "validate": {
          "pattern": "^[0-9]+$"
        }
      },
      {
        "label": "Telephone number",
        "inputMask": "(99) 9999-9999",
        "tableView": true,
        "persistent": true,
        "key": "representative1TelephoneNumber",
        "type": "textfield",
        "input": true,
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.representative1"
              },
              "yes"
            ]
          }
        }
      },

      {
        "label": "Email",
        "tableView": true,
        "key": "representative1Email",
        "type": "email",
        "input": true,
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.representative1"
              },
              "yes"
            ]
          }
        }
      },
      // party1 start end

      //party2 start
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Party 2 Name (Company)",
        "key": "party2NameCompany",
        "placeholder": "Name",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        type: "select",
        label: "Role in dispute",
        key: "roleInDisputeParty2",
        placeholder: "Select one",
        data: {
          values: [
            { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
            { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
            { value: 'partyInArbitration', label: 'Party In Arbitration' }
          ]
        },
        "validate": {
          "required": true
        },
        dataSrc: "values",
        defaultValue: '',
        template: "<span>{{ item.label }}</span>",
        input: true,
        //"conditional": {
        //  "json": {
        //    "===": [
        //      {
        //        "var": "data.typeOfDisputeResolver"
        //      },
        //      "arbitrator"
        //    ]
        //  }
        //}
      },
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDisputeParty2",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInMediation', label: 'Party In Mediation' }
      //    ]
      //  },
      //  "validate": {
      //    "required": true
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  "conditional": {
      //    "json": {
      //      "===": [
      //        {
      //          "var": "data.typeOfDisputeResolver"
      //        },
      //        "mediator"
      //      ]
      //    }
      //  }
      //},
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDisputeParty2",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInConciliation', label: 'Party In Conciliation' }
      //    ]
      //  },
      //  "validate": {
      //    "required": true
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  "conditional": {
      //    "json": {
      //      "===": [
      //        {
      //          "var": "data.typeOfDisputeResolver"
      //        },
      //        "conciliator"
      //      ]
      //    }
      //  }
      //},
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDisputeParty2",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInExpertDetermination', label: 'Party In Expert Determination' }
      //    ]
      //  },
      //  "validate": {
      //    "required": true
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  "conditional": {
      //    "json": {
      //      "===": [
      //        {
      //          "var": "data.typeOfDisputeResolver"
      //        },
      //        "expert Determiner"
      //      ]
      //    }
      //  }
      //},
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Contact Given name",
        "key": "contactGivenNameParty2",
        "placeholder": "Name",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Contact Surname",
        "key": "contactSurnameParty2",
        "placeholder": "Surname",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Position",
        "key": "positionParty2",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postal Address",
        "key": "postalAddressParty2",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Suburb",
        "key": "suburbParty2",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "State",
        "key": "stateParty2",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postcode",
        "key": "postCodeParty2",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false,
          "pattern": "^[0-9]+$"
        }
      },
      {
        "label": "Telephone number",
        "inputMask": "(99) 9999-9999",
        "tableView": true,
        "persistent": true,
        "validate": {
          "required": false,
          "customPrivate": false
        },
        "key": "telephoneNumber2",
        "type": "textfield",
        "input": true
      },

      {
        "label": "Email",
        "tableView": true,
        "validate": {
          "required": true
        },
        "key": "emailParty2",
        "type": "email",
        "input": true
      },
      {
        "type": "radio",
        "label": "Representative",
        "input": true,
        "inline": true,
        "tableView": false,
        "key": "representative2",
        "persistent": true,
        values: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        "validate": {
          "required": true
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Firm/Chambers",
        "key": "representative2FirmChambers",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative2"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Name of representative",
        "key": "nameOfRepresentative2",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative2"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postal Address",
        "key": "representative2PostalAddress",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative2"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Suburb",
        "key": "representative2Suburb",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative2"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "State",
        "key": "representative2State",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative2"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postcode",
        "key": "representative2PostCode",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative2"
              },
              "yes"
            ]
          }
        },
        "validate": {
          "pattern": "^[0-9]+$"
        }
      },
      {
        "label": "Telephone number",
        "inputMask": "(99) 9999-9999",
        "tableView": true,
        "persistent": true,
        "key": "representative2TelephoneNumber",
        "type": "textfield",
        "input": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative2"
              },
              "yes"
            ]
          }
        }
      },

      {
        "label": "Email",
        "tableView": true,
        "key": "representative2Email",
        "type": "email",
        "input": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative2"
              },
              "yes"
            ]
          }
        }
      },
      //party2 end
      //party3 start
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Party 3 Name (Company)",
        "key": "party2NameCompany",
        "placeholder": "Name",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "customPrivate": false
        }
      },
      {
        type: "select",
        label: "Role in dispute",
        key: "roleInDisputeParty3",
        placeholder: "Select one",
        data: {
          values: [
            { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
            { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
            { value: 'partyInArbitration', label: 'Party In Arbitration' }
          ]
        },
        dataSrc: "values",
        defaultValue: '',
        template: "<span>{{ item.label }}</span>",
        input: true,
        //"conditional": {
        //  "json": {
        //    "===": [
        //      {
        //        "var": "data.typeOfDisputeResolver"
        //      },
        //      "arbitrator"
        //    ]
        //  }
        //}
      },
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDisputeParty3",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInMediation', label: 'Party In Mediation' }
      //    ]
      //  },
      //  "validate": {
      //    "required": true
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  "conditional": {
      //    "json": {
      //      "===": [
      //        {
      //          "var": "data.typeOfDisputeResolver"
      //        },
      //        "mediator"
      //      ]
      //    }
      //  }
      //},
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDisputeParty3",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInConciliation', label: 'Party In Conciliation' }
      //    ]
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  "conditional": {
      //    "json": {
      //      "===": [
      //        {
      //          "var": "data.typeOfDisputeResolver"
      //        },
      //        "conciliator"
      //      ]
      //    }
      //  }
      //},
      //{
      //  type: "select",
      //  label: "Role in dispute",
      //  key: "roleInDisputeParty3",
      //  placeholder: "Select one",
      //  data: {
      //    values: [
      //      { value: 'applicantCoApplicant', label: 'Applicant/Co-applicant' },
      //      { value: 'respondentCoRespondent', label: 'Respondent/Co-respondent' },
      //      { value: 'partyInExpertDetermination', label: 'Party In Expert Determination' }
      //    ]
      //  },
      //  dataSrc: "values",
      //  defaultValue: '',
      //  template: "<span>{{ item.label }}</span>",
      //  input: true,
      //  "conditional": {
      //    "json": {
      //      "===": [
      //        {
      //          "var": "data.typeOfDisputeResolver"
      //        },
      //        "expert Determiner"
      //      ]
      //    }
      //  }
      //},
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Contact Given name",
        "key": "contactGivenNameParty3",
        "placeholder": "Name",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Contact Surname",
        "key": "contactSurnameParty3",
        "placeholder": "Surname",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Position",
        "key": "positionParty3",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postal Address",
        "key": "postalAddressParty3",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Suburb",
        "key": "suburbParty3",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "State",
        "key": "stateParty3",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "customPrivate": false
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postcode",
        "key": "postCodeParty3",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "customPrivate": false,
          "pattern": "^[0-9]+$"
        }
      },
      {
        "label": "Telephone number",
        "inputMask": "(99) 9999-9999",
        "tableView": true,
        "persistent": true,
        "validate": {
          "required": false,
          "customPrivate": false
        },
        "key": "telephoneNumber3",
        "type": "textfield",
        "input": true
      },

      {
        "label": "Email",
        "tableView": true,
        "key": "emailParty3",
        "type": "email",
        "input": true
      },
      {
        "type": "radio",
        "label": "Representative",
        "input": true,
        "inline": true,
        "tableView": false,
        "key": "representative3",
        "persistent": true,
        values: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Firm/Chambers",
        "key": "representative3FirmChambers",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative3"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Name of representative",
        "key": "nameOfRepresentative3",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative3"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postal Address",
        "key": "representative3PostalAddress",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative3"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Suburb",
        "key": "representative3Suburb",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative3"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "State",
        "key": "representative3State",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative3"
              },
              "yes"
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Postcode",
        "key": "representative3PostCode",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative3"
              },
              "yes"
            ]
          }
        },
        "validate": {
          "pattern": "^[0-9]+$"
        }
      },
      {
        "label": "Telephone number",
        "inputMask": "(99) 9999-9999",
        "tableView": true,
        "persistent": true,
        "key": "representative3TelephoneNumber",
        "type": "textfield",
        "input": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative3"
              },
              "yes"
            ]
          }
        }
      },

      {
        "label": "Email",
        "tableView": true,
        "key": "representative3Email",
        "type": "email",
        "input": true,
        conditional: {
          "json": {
            "===": [
              {
                "var": "data.representative3"
              },
              "yes"
            ]
          }
        }
      },
      //party3 end

      // Add any other parties as a text area
      {
        "type": "textarea",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Mention any other parties",
        "key": "otherParties",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true
      },
      {
        type: "select",
        label: "State in which the work has taken place / Relevant State jurisdiction",
        key: "stateInWhichTheWorkTookPlace",
        placeholder: "Select one",
        data: {
          values: [
            { value: 'ACT', label: 'ACT' },
            { value: 'NSW', label: 'NSW' },
            { value: 'NT', label: 'NT' },
            { value: 'QLD', label: 'QLD' },
            { value: 'SA', label: 'SA' },
            { value: 'TAS', label: 'TAS' },
            { value: 'VIC', label: 'VIC' },
            { value: 'WA', label: 'WA' },
            { value: 'Other', label: 'Other' }
          ]
        },
        "validate": {
          "required": true
        },
        dataSrc: "values",
        defaultValue: '',
        template: "<span>{{ item.label }}</span>",
        input: true
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Mention which state",
        "key": "stateInWhichTheWorkTookPlaceOther",
        "placeholder": "Name",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        },
        "conditional": {
          "json": {
            "===": [
              {
                "var": "data.stateInWhichTheWorkTookPlac"
              },
              "other"
            ]
          }
        }
      },
      {
        type: "select",
        label: "Source of referral to Resolution Institute",
        key: "sourceOfReferral",
        placeholder: "Select one",
        data: {
          values: [
            { value: 'contractDisputeResolution', label: 'Contract - dispute resolution' },
            { value: 'clause', label: 'Clause' },
            { value: 'courtOrder', label: 'Court Order' },
            { value: 'referralFromOther', label: 'Referral from other Organisation/body (please specify)' },
            { value: 'mutualConsent', label: 'Mutual consent' },
            { value: 'other', label: 'Other (please specify)' }
          ]
        },
        "validate": {
          "required": true
        },
        dataSrc: "values",
        defaultValue: '',
        template: "<span>{{ item.label }}</span>",
        input: true
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Please mention source of referral",
        "key": "nameOfBodyAuthorisedToMakeNomination",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "conditional": {
          "json": {
            "in": [
              {
                "var": "data.sourceOfReferral"
              },
              ["referralFromOther", "other"]
            ]
          }
        }
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Name of body authorised to make nomination",
        "key": "nameOfBodyAuthorisedToMakeNomination",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true
      },
      {
        "type": "textfield",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "Dispute area(s) (technical subject or industry)",
        "key": "disputeArea",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "label": "Approximate value of dispute",
        "mask": false,
        "spellcheck": true,
        "tableView": false,
        "currency": "AUD",
        "inputFormat": "plain",
        "key": "approximateValueOfDispute",
        "type": "currency",
        "input": true,
        "delimiter": true,
        "validate": {
          "required": true,
          "customPrivate": false
        }
      },
      {
        "type": "textarea",
        "input": true,
        "tableView": true,
        "inputType": "text",
        "inputMask": "",
        "label": "General nature of dispute\u00A0/\u00A0relevant details",
        "key": "generalNatureOfDispute",
        "placeholder": "",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "defaultValue": "",
        "protected": false,
        "unique": false,
        "persistent": true
      },
      // Add upload clauses
      {
        "type": "fileupload",
        "label": "Dispute clauses",
        "disabled": false,
        "value": 1,
        "placeholder": "Dispute clauses"
      },
      {
        "type": "fileupload",
        "label": "Notice of dispute",
        "disabled": false,
        "value": 1,
        "placeholder": "Notice of dispute"
      },
      {
        "type": "fileupload",
        "label": "If dispute resolution clause refers to other documents, please attach here",
        "disabled": false,
        "value": 1,
        "placeholder": "Dispute resolution documents"
      },
      {
        "type": "fileupload",
        "label": "Other documents (e.g. overview of nomination process to date, and background documentation)",
        "disabled": false,
        "value": 1,
        "placeholder": "Other documents"
      },
      {
        "type": "htmlelement",
        "input": false,
        "tableView": true,
        "content": "Declaration: I hereby declare that:",
        "inputMask": "",
        "key": "declarationText",
        "prefix": "",
        "suffix": "",
        "multiple": false,
        "protected": false,
        "unique": false,
        "persistent": true
      },
      {
        "type": "radio",
        "label": "The Information provided in this application is, to the best of my knowledge, accurate and truthful",
        "input": true,
        "inline": true,
        "tableView": false,
        "key": "declaration",
        "persistent": true,
        values: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        "validate": {
          "required": true
        }
      },
      {
        "type": "radio",
        "label": "I have the authority to complete this Application as the Applicant or Applicant’s Representative",
        "input": true,
        "inline": true,
        "tableView": false,
        "key": "authorityToCompleteApplication",
        "persistent": true,
        values: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ],
        "validate": {
          "required": true
        }
      },
      {
        "type": "button",
        "label": "Submit",
        "key": "submit",
        "disableOnInvalid": false,
        "input": true,
        "tableView": false
      }
    ];

    this.formComponents = [{
      "title": "Form details",
      "key": "panel",
      "type": "panel",
      "components": formComponents
    }]

    this.formSpec = {
      "title": "My Test Form",
      "components": this.formComponents
    }
    this.triggerRefresh = new EventEmitter();
    if (this.jsonDataUrl != undefined) {
      var that = this;
      this.httpClient.get<any>(this.baseUrl + 'api/SampleData/GetJsonData?filepath=' + this.jsonDataUrl).subscribe(data1 => {
        that.formData = {
          data: data1
        }
      })
    } else {
      this.formData = {
        data: {
          // "firstName": "Laksh",
          // "lastName": "Mikkil
          "formName": "arb-exp",
          "formId": this.formId,
        }
      }
    }    
    
  }
  onChange(event: any) {
   
    if (event.changed) {     
      console.log(event.changed);
      if (event.changed.component.key === 'typeOfDisputeResolver') {
        var disputeParty1 = this.getFormComponent('roleInDispute')
        if (disputeParty1.data.values.length > 2) {
          disputeParty1.data.values.pop();
        }
        var disputeParty2 = this.getFormComponent('roleInDisputeParty2')
        if (disputeParty2.data.values.length > 2) {
          disputeParty2.data.values.pop();
        }
        var disputeParty3 = this.getFormComponent('roleInDisputeParty3')
        if (disputeParty3.data.values.length > 2) {
          disputeParty3.data.values.pop();
        }
        console.log(event.changed.value);
        if (event.changed.value === 'arbitrator') {
          
          disputeParty1.data.values.push({ value: "partyInArbitrator", label: "Party In Arbitration" });
          disputeParty2.data.values.push({ value: "partyInArbitrator", label: "Party In Arbitration" });
          disputeParty3.data.values.push({ value: "partyInArbitrator", label: "Party In Arbitration" });
        }
        else if (event.changed.value === 'mediator') {
          disputeParty1.data.values.push({ value: "partyInMediation", label: "Party In Mediation" });
          disputeParty2.data.values.push({ value: "partyInMediation", label: "Party In Mediation" });
          disputeParty3.data.values.push({ value: "partyInMediation", label: "Party In Mediation" });
        }
        else if (event.changed.value === 'conciliator') {
          disputeParty1.data.values.push({ value: "partyInConciliation", label: "Party In Conciliation" });
          disputeParty2.data.values.push({ value: "partyInConciliation", label: "Party In Conciliation" });
          disputeParty3.data.values.push({ value: "partyInConciliation", label: "Party In Conciliation" });
        }
        else if (event.changed.value === 'expert Determiner') {
          disputeParty1.data.values.push({ value: "partyInExpertDetermination", label: "Party In Expert Determination" });
          disputeParty2.data.values.push({ value: "partyInExpertDetermination", label: "Party In Expert Determination" });
          disputeParty3.data.values.push({ value: "partyInExpertDetermination", label: "Party In Expert Determination" });
        }
        //console.log(this.formComponents[4]);
        //
        this.triggerRefresh.emit({
          form: this.formSpec

        })
      }
    }
  }
  getFileString(urls) {
    var fileString = "";
    urls.forEach(function (item) {
      if (item.key != AppService.generatedPdfKey) {
        var urlTemp = item.url.toString().split("//");
        console.log(urlTemp);
        fileString += urlTemp[urlTemp.length - 1] + ",";
      }
    });
    if (fileString.length > 0) {
      return fileString.substr(0, fileString.length - 1);
    }
    return fileString;
  }
  getFormComponent(key: string) {
    var foundComp;
    this.formComponents.forEach(function (comp) {
      //console.log(comp);
      if (comp.key === key)
        foundComp = comp;
    });
    return foundComp;
  }
  onSubmit(form: any) {
    var serviceResponse = this.appService.getUrls();
    var pdfUrl = "/documents/" + this.formId + ".pdf";
    var pdfData = {
      "key": AppService.generatedPdfKey,
      "url": []
    };
    pdfData.url.push(pdfUrl);
    serviceResponse.push(pdfData);
    let today = new Date();
    form.data.submission_date = today.toString()
    form.data.files_submitted = this.appService.getUploadedFilesString();
    
    var jsonToServer = {
      ...{ "Submission Date": today.toString() }, ...form.data, ...{ files: serviceResponse }, ...{ submission_date: today.toString() }
    
    };

    let jsonToServer_ = JSON.parse(JSON.stringify(jsonToServer))

    
    today.setHours(0, 0, 0, 0);
    let newComponent = {
      "type": "textfield",
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "Date Submitted",
      "key": "submission_date",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "Test_Default",
      "protected": false,
      "unique": false,
      "persistent": true,
      "conditional": {
        "json": {
          "===": [
            {
              "var": "data.submission_date"
            },
            "yes"
          ]
        }
      }
    };
    let filesComponent = {
      "type": "textfield",
      "input": true,
      "tableView": true,
      "inputType": "text",
      "inputMask": "",
      "label": "Files Submitted",
      "key": "files_submitted",
      "placeholder": "",
      "prefix": "",
      "suffix": "",
      "multiple": false,
      "defaultValue": "Test_Default",
      "protected": false,
      "unique": false,
      "persistent": true,
      "conditional": {
        "json": {
          "===": [
            {
              "var": "data.files_submitted"
            },
            "yes"
          ]
        }
      }
    };
    this.formComponents[0].components.unshift(<any>filesComponent);
    this.formComponents[0].components.unshift(<any>newComponent);

    let component = {
      type: 'form',
      title: 'Resolution Institute Quickfiles application',
      display: 'form',
      components: this.formComponents,
     
    };
    
    let submission = {
      //owner: jsonToServer_.formName,
      //_id: this.formId,
      //modified: today.toDateString(),
      data: jsonToServer     
    };

    let options = {
      ignoreLayout: true
    };

    let exporter = new FormioExport(component, submission, options);

    let config = {
      download: false,
      filename: this.formId + '.pdf'
    };

    /*
    exporter.toPdf(config).then((pdf) => {
      // download the pdf file
      pdf.save(config.filename);
    });
    */

    exporter.toPdf(config).then((pdf) => {
      return pdf.output('datauristring');
    }).then((datauri_base64) => {
      if (datauri_base64) {
        // console.log(datauri_base64);

        var pdfObject = {};
        pdfObject["base64file"] = datauri_base64;
        pdfObject["filename"] = config.filename;

        this.httpClient.post<any>(this.baseUrl + 'api/SampleData/SaveToPdf', pdfObject).subscribe(result => {
          if (result) {
            console.log('PDF uploaded!!');

            this.httpClient.post<any>(this.baseUrl + 'api/SampleData/PostFormData', jsonToServer).subscribe(result => {
              if (result) {
                console.log('Form data uploaded!!');

                this.router.navigateByUrl('/thankyou');
              }
              else {
                alert('There was an error with the submision, please try again. -1');

                return false;
              }
            }, error => {
              console.error(error);

              return false;
            });
          }
          else {
            alert('There was an error with the submision, please try again. -2');

            return false;
          }
        }, error => {
          console.error(error);

          return false;
        });
      }
    }).catch(function (error) {
      alert('There was an error with the submision, please try again. -3');

      return false;
    });

  }

}

